"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TraceTeamInfoCard = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../..");

require("./TraceTeamInfoCard.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Drew Burnett
 */
// Import
// Trace Team Info Card
var TraceTeamInfoCard = function TraceTeamInfoCard(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      buttonTitle = _ref.buttonTitle,
      onButtonClick = _ref.onButtonClick,
      renderAsRow = _ref.renderAsRow;

  var handleOnButtonClick = function handleOnButtonClick(e) {
    if (typeof onButtonClick === "function") {
      onButtonClick(e);
    }
  };

  var rowStyles = renderAsRow ? "as-row" : "";
  var primaryStyles = renderAsRow ? "" : "primary";
  return /*#__PURE__*/_react.default.createElement(_.Row, {
    className: "TraceTeamInfoCard ".concat(rowStyles)
  }, /*#__PURE__*/_react.default.createElement(_.Column, {
    className: "left-column",
    alignItems: "center",
    justifyContent: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    className: "title",
    color: _.Color.Black,
    type: _.Label.Type.Body,
    left: true,
    bold: true
  }, title), /*#__PURE__*/_react.default.createElement(_.Label, {
    className: "subtitle",
    color: _.Color.Grey1,
    type: _.Label.Type.SmallBody
  }, subtitle)), /*#__PURE__*/_react.default.createElement(_.Column, {
    className: "right-column",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react.default.createElement(_.Button, {
    small: true,
    className: "".concat(primaryStyles),
    trkAction: "Learn More Pressed",
    onClick: function onClick(e) {
      return handleOnButtonClick(e);
    },
    content: /*#__PURE__*/_react.default.createElement(_.Row, {
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_.Icon, {
      size: 16,
      type: _.Icon.Type.Upgrade
    }), /*#__PURE__*/_react.default.createElement(_.Label, {
      type: _.Label.Type.InnerButton,
      content: buttonTitle,
      marginLeft: "2"
    }))
  })));
};

exports.TraceTeamInfoCard = TraceTeamInfoCard;
TraceTeamInfoCard.defaultProps = {
  title: 'Trace Team',
  subtitle: 'Unlock tactical playlists, expert coaching, and save!',
  buttonTitle: 'Learn More',
  renderAsRow: false
};